import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { NotificationModel } from '../../models/NotificationModel';
import { IdleUserService } from '../../services/idle.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, OnDestroy {
  showToast = false;
  seconds = 60;
  private sub!: Subscription;

  constructor(
    private notificationService: NotificationService,
    private idleService: IdleUserService
  ) {}

  get urgency(): 'warning' | 'danger' | 'critical' {
    if (this.seconds <= 15) return 'critical';
    if (this.seconds <= 30) return 'danger';
    return 'warning';
  }

  get progress(): number {
    const total = parseFloat(localStorage.getItem('timeOut') || '60');
    return total > 0 ? (this.seconds / total) * 100 : 0;
  }

  ngOnInit() {
    this.sub = this.notificationService.notifyRequest$.subscribe((n: NotificationModel) => {
      this.showToast = n.status;
      this.seconds = n.seconds;
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  keepWorking() {
    this.idleService.reset();
  }
}
